<template>
    <div class="videoContainer" v-if="videoPlaying">
        <video id="video_clips" width="100%" height="100%" v-if="play180 == true" muted>
            <source src="/videos/testvideo.webm" type="video/webm">
            <source src="/videos/testvideo.mp4" type="video/mp4">
        </video>
    </div>
</template>

<script>
    export default {
        props: ['throwPoints'],
        data() {
            return {
                play180: false,
                videoPlaying: false,
            }
        },
        watch: {
            throwPoints: function(newVal, oldVal) {
            this.checkScoreForVideo(newVal)
            }
        },
        mounted() {
        },
        methods: {
            checkScoreForVideo(score) {
                if (score == 180) {
                    this.playVideo()
                }
            },
            playVideo() {
                return; // DO NOT PLAY VIDEOS RIGHT NOW
                this.videoPlaying = true;
                this.play180 = true;
                var self = this;
                setTimeout(e => {
                    var myVideo = document.getElementById("video_clips");
                    myVideo.play();

                    myVideo.onended = function() {
                        self.play180 = false;
                        self.videoPlaying = false;
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .videoContainer {
        position: absolute;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
        z-index: 50000;
    }
</style>
